// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__vIPVW","savePackageButton":"ClientWallet_savePackageButton__119fj"};